import { InjectionToken, Provider } from '@angular/core';

import { IssueArchivedSocketEventHandler } from './issue-archived.se-handler';
import { IssueCreatedSocketEventHandler } from './issue-created.se-handler';
import { IssueStatusUpdatedSocketEventHandler } from './issue-status-updated.se-handler';
import { IssueTypesUpdatedSocketEventHandler } from './issue-types-updated.se-handler';
import { POICategoriesUpdatedSocketEventHandler } from './poi-categories-updated.se-handler';
import { TaskArchivedSocketEventHandler } from './task-archived.se-handler';
import { TaskAssignedSocketEventHandler } from './task-assigned.se-handler';
import { TaskCreatedSocketEventHandler } from './task-created.se-handler';
import { TaskPatchedSocketEventHandler } from './task-patched.se-handler';
import { TaskPublishedSocketEventHandler } from './task-published.se-handler';
import { TaskStatusUpdatedSocketEventHandler } from './task-status-updated.se-handler';
import { TaskTypesUpdatedSocketEventHandler } from './task-types-updated.se-handler';
import { TaskUnassignedSocketEventHandler } from './task-unassigned.se-handler';

/**
 * Multi-provider token collecting every socket event handler. Injecting it
 * instantiates each handler (via `useExisting` on the root singletons), which
 * is what wires up their socket subscriptions. The `handlers` array below is
 * the single source of truth — add new handlers here.
 */
export const SOCKET_EVENT_HANDLERS = new InjectionToken<unknown[]>('SOCKET_EVENT_HANDLERS');

const handlers = [
    IssueArchivedSocketEventHandler,
    IssueCreatedSocketEventHandler,
    IssueStatusUpdatedSocketEventHandler,
    IssueTypesUpdatedSocketEventHandler,
    POICategoriesUpdatedSocketEventHandler,
    TaskArchivedSocketEventHandler,
    TaskAssignedSocketEventHandler,
    TaskCreatedSocketEventHandler,
    TaskPatchedSocketEventHandler,
    TaskPublishedSocketEventHandler,
    TaskStatusUpdatedSocketEventHandler,
    TaskTypesUpdatedSocketEventHandler,
    TaskUnassignedSocketEventHandler,
];

export const socketEventHandlerProviders: Provider[] = handlers.map(
    (useExisting): Provider => ({
        provide: SOCKET_EVENT_HANDLERS,
        useExisting,
        multi: true,
    })
);
